import { useTheme } from "@/theme/ThemeProvider";
import { PRIVACY_NOTICE_TEXT } from "@/ui/finder/finderMode";
import { Text, View } from "react-native";

/** Nur der Hinweistext. Kennt weder Checkbox noch Art der Bereitstellung. */
export function FinderPrivacyNotice({ version }: { version: string }) {
  const { theme } = useTheme();

  return (
    <View
      style={{
        gap: theme.space.xs,
        padding: theme.space.sm,
        borderRadius: theme.radius.md,
        borderWidth: 1,
        borderColor: theme.color.border,
        backgroundColor: theme.color.surface,
      }}
    >
      <Text
        style={{
          color: theme.color.text,
          fontWeight: "700",
          fontSize: theme.fontSize.body,
        }}
      >
        Datenschutzinformation
      </Text>
      <Text
        style={{
          color: theme.color.textSecondary,
          fontSize: theme.fontSize.body,
          lineHeight: 22,
        }}
      >
        {PRIVACY_NOTICE_TEXT}
      </Text>
      <Text style={{ color: theme.color.muted, fontSize: theme.fontSize.small }}>
        Version {version}
      </Text>
    </View>
  );
}
